import {RouterPaths} from "../routerPaths";
import {importPages} from "../lazyRoute";

const dashboardRoutes = [
    {
        path: RouterPaths.DASHBOARD,
        element: importPages.Dashboard,
    },

]
export default dashboardRoutes